import { theme } from "theme";
import { styled } from "styled-components";
import { Image } from "antd";

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100% !important;

  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: ${theme?.borderRadius?.base};
  border: 1px solid ${theme?.color?.borderLight};

  -webkit-user-drag: none; /* For WebKit browsers (Chrome, Safari, Edge) */
  -moz-user-drag: none; /* For Mozilla Firefox */
  -ms-user-drag: none; /* For Internet Explorer/Edge (older versions) */
`;

export const Wrapper = styled.div`
  position: relative;

  .ant-image {
    height: 100%;
  }
`;
